import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { first } from 'rxjs/operators';
import { ReportsService } from 'src/app/shared';

@Component({
  selector: 'app-candidate-verification-status',
  templateUrl: './candidate-verification-status.component.html',
  styleUrls: ['./candidate-verification-status.component.scss']
})
export class CandidateVerificationStatusComponent implements OnChanges {

  @Input() center: any;
  @Input() batch: any;
  @Input() verificationStatus: string = 'all';

  rows: any[] = [];
  loading = false;
  error = '';
  selectedStatus = 'all';
  expandedCandidateId: any = null;
  expandedBatchId: any = null;

  statusOptions = [
    { value: 'all', label: 'All' },
    { value: 'Verified', label: 'Allowed' },
    { value: 'Partial', label: 'Partially Allowed' },
    { value: 'Rejected', label: 'Disallowed' },
    { value: 'pending', label: 'Pending' }
  ];

  private statusLabelMap: { [key: string]: string } = {
    verified: 'Allowed',
    allowed: 'Allowed',
    approved: 'Allowed',
    partial: 'Partially Allowed',
    partially_allowed: 'Partially Allowed',
    partiallyallowed: 'Partially Allowed',
    rejected: 'Disallowed',
    disallowed: 'Disallowed',
    pending: 'Pending',
    all: 'All'
  };

  constructor(private reportsService: ReportsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.verificationStatus && changes.verificationStatus.currentValue !== undefined) {
      this.selectedStatus = changes.verificationStatus.currentValue || '';
    }

    if ((changes.center && this.center) || (changes.batch && this.batch) || (changes.verificationStatus)) {
      this.fetch();
    }
  }

  get centerCode(): any {
    return   this.center;
  }

  get batchCode(): any {
    return  this.batch;
  }

  statusLabel(status: string): string {
    if (status === null || status === undefined || status === '') {
      return 'Pending';
    }
    const key = String(status).trim().toLowerCase().replace(/[\s-]+/g, '_');
    return this.statusLabelMap[key] || String(status);
  }

  fetch(): void {
    if (!this.centerCode || !this.batchCode) {
      return;
    }

    this.loading = true;
    this.error = '';

    this.reportsService.getVerificationStatus(this.centerCode, this.batchCode, this.selectedStatus)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          this.rows = res || [];
          this.loading = false;
        },
        error: () => {
          this.error = 'Unable to load verification status right now.';
          this.loading = false;
        }
      });
  }

  refresh(): void {
    this.fetch();
  }

  isPass(flag: any): boolean {
    return flag === true || flag === 1 || flag === 'Y' || flag === 'true' || flag === '1';
  }

  toggleExpand(cand: any) {
    console.log('Toggling expand for candidate:', cand);
    const candId = cand.can_userid;
    const batchId = cand.batch_id;
    if (this.expandedCandidateId === candId) {
      this.expandedCandidateId = null;
      this.expandedBatchId = null;
    } else {
      this.expandedCandidateId = candId;
      this.expandedBatchId = batchId;
    }
  }
}
